import { InvoiceStatus } from "@jugl-web/rest-api/invoices/models/common-types";

export const statusOptions: Array<{
  id: InvoiceStatus;
  value: string;
}> = [
  { value: "Issued", id: "issued" },
  { value: "Void", id: "void" },
  { value: "Draft", id: "draft" },
  { value: "Pending", id: "pending" },
  { value: "Long Term Due", id: "long_term_due" },
  { value: "Paid", id: "paid" },
  { value: "Partially Paid", id: "partially_paid" },
  { value: "Overdue", id: "overdue" },
];
